import { AxiosResponse } from 'axios';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { Result } from '@/main/models/common/resultResponse';
import { TireBrandRequest, TireBrandSaveRequest } from '@/main/models/request/tireBrandRequest';
import { TireBrandResponse } from '@/main/models/response/tireBrandResponse';
import { KeyValue } from '@/main/models/common';

export abstract class IPartBrandApi {
  abstract getDomain(idBrandType: number): Promise<AxiosResponse<Result<KeyValue[]>>>;
  abstract getSearchGrid(request: TireBrandRequest): Promise<AxiosResponse<PaginationResponse<TireBrandResponse[]>>>;
  abstract saveTireBrand(request: TireBrandSaveRequest): Promise<AxiosResponse<Result<TireBrandResponse>>>;
}



